import React from "react";

const SuperBowlChamp = ({ team, trophy }) => {
  console.log(`url(${team["logo"]})`, `url(${trophy["logo"]})`);
  return (
    <div
      className="winner"
      style={{
        backgroundImage: team.logo
          ? `url(${team["logo"]})`
          : `url(${trophy["logo"]})`,
        backgroundSize: "contain"
      }}
    ></div>
  );
};

export default SuperBowlChamp;
